var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex flex-column align-items-center justify-content-center card-container h-screen pl-2"},[_c('h1',{staticClass:"titulo text-8xl text-black font-Impact"},[_vm._v(_vm._s(_setup.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }